import { Box } from "@mui/material";

// Reusable Circle component
const Circle = ({ top, left, background }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        width: 634,
        height: 634,
        top,
        left,
        background,
        filter: "blur(1000px)",
        borderRadius: "50%",
      }}
    />
  );
};

// BackgroundCircles component using the reusable Circle
const BackgroundCircles = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        zIndex: -1,
      }}
    >
      <Circle top={-280} left={-317} background="#52BDAA" />
      <Circle top={270} left={1123} background="#54BE96" />
      <Circle top={219} left={376} background="white" />
    </Box>
  );
};

export default BackgroundCircles;
